import React, { Suspense, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/main.scss";
import Loading from "./components/Loading";

// Lazy load components
const Home = React.lazy(() => import("./pages/Home"));
const Leasing = React.lazy(() => import("./pages/Leasing"));
const Contact = React.lazy(() => import("./pages/Contact"));
const Relocation = React.lazy(() => import("./pages/Relocation"));
const Blog = React.lazy(() => import("./pages/Blog"));
const BlogPost = React.lazy(() => import("./pages/BlogPost"));
const TeamMember = React.lazy(() => import("./pages/TeamMember"));
const NotFound = React.lazy(() => import("./pages/NotFound"));
const AdminApp = React.lazy(() => import("./pages/AdminApp"));

const App = () => {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <Suspense fallback={<Loading fullScreen />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/leasing/*" element={<Leasing />} />
            <Route path="/leasing/complete" element={<Leasing isComplete />} />
            <Route path="/leasing/all" element={<Leasing isAll />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/relocation" element={<Relocation />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/team/:slug" element={<TeamMember />} />
            <Route path="/admin/*" element={<AdminApp />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </Router>
    </HelmetProvider>
  );
};

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default App;
